import { HeaderCategoryTrigger } from '@/widgets/CategoryDropdown/HeaderCategoryTrigger';
import { HeaderCartAction } from '@/widgets/HeaderCartActionWidget';
import { HeaderLogoWidget } from '@/widgets/HeaderLogoWidget';

import { HeaderAction } from './Action/HeaderAction';
import { HeaderBottom } from './Bottom/HeaderBottom';
import { HeaderContent } from './Content/HeaderContent';
import { Header as HeaderRoot } from './Header';
import { HeaderLeft } from './Left/HeaderLeft';
import { HeaderRight } from './Right/HeaderRight';
import { HeaderTitle } from './Title/HeaderTitle';
import { HeaderTop } from './Top/HeaderTop';

export const Header = Object.assign(HeaderRoot, {
  Top: HeaderTop,
  Left: HeaderLeft,
  Right: HeaderRight,
  Bottom: HeaderBottom,
  Content: HeaderContent,
  Title: HeaderTitle,
  Action: HeaderAction,
  /**
   * widget-backed — bi 응답에서 logo URL 자동 fetch + DefaultBrandLogo fallback.
   * `logo` prop 명시 시 dumb mode (BC). CoreUIDataProvider 부재 시 DefaultBrandLogo + dev warn.
   */
  Logo: HeaderLogoWidget,
  /**
   * widget-backed preset — CategoryDropdown 와 자동 연동.
   * Header 의 다른 dot-notation 들 (Top/Left/Right/Bottom/Content/Title/Action) 은 dumb.
   * Logo / CategoryTrigger / CartAction 만 widget-backed.
   */
  CategoryTrigger: HeaderCategoryTrigger,
  /**
   * widget-backed — Provider 의 cart 도메인 entry 를 자동 구독하여 showDot 결정.
   * host fetcher 가 `fetchers.cart` 로 주입되어야 동작. Provider 부재 시 showDot=false + dev warn.
   * 호스트가 자체 cart store 사용 원하면 `<Header.Action action="cart" showDot={...} />` 직접 사용.
   */
  CartAction: HeaderCartAction,
});
